export default __webpack_public_path__ + "static/Continuous Integration 8_1-778990d1705b1f3d5efa2df4a1e361e8.png";